import { objectOf, maybe } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isEngagementApprovalsContextIdApproveAllResult = objectOf({
  info: maybe(string),
  warn: maybe(string),
});
